export const GET_DATA_PORTAL = "GET_DATA_PORTAL";
export const RESET_DATA_DETAIL_PORTAL = "RESET_DATA_DETAIL_PORTAL";
export const START_LOADING_PORTAL = "START_LOADING_PORTAL";
export const STOP_LOADING_PORTAL = "STOP_LOADING_PORTAL";
export const ERROR_LOADING_PORTAL = "ERROR_LOADING_PORTAL";